import request from "utils/request";
import requestJWT from "utils/requestJWT";

const getPointApi = async (id) => {
    return await request.get(`/ratting-comment/${id}/get-point`);
};

const createRateApi = async (data) => {
    return await requestJWT.post(`/ratting-comment/create`, data);
};

const getRattingDataApi = async (id, page, sort, star) => {
    return await request.get(`/ratting-comment/${id}/get-by-tour?page=${page}&item=5&sort=${sort}&star=${star}`);
};

const removeRateApi = async (id) => {
    return await requestJWT.delete(`/ratting-comment/${id}/remove`);
};


const updateRateApi = async (id, data) => {
    return await requestJWT.put(`/ratting-comment/${id}/update`, data);
};

export {
    getPointApi,
    createRateApi,
    getRattingDataApi,
    removeRateApi,
    updateRateApi
};
